/**
 * Replaces newline characters (\n) with HTML <br /> tags.
 * Useful for displaying multi-line text in HTML format.
 * @param text - The input string to process
 * @returns A string with <br /> tags replacing newline characters or an empty string if no text is provided
 * @example
 * const text = "Hello\nWorld";
 * const result = addLineBreaksAsHTML(text);
 * // result: "Hello<br />World"
 */
export const addLineBreaksAsHTML = (text?: string): string => {
  return text ? text.replace(/\n/g, '<br />') : '';
};
